import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=789fd347&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Institutions.vue?vue&type=script&lang=js&"
export * from "./Institutions.vue?vue&type=script&lang=js&"
import style0 from "./Institutions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports